import EyeDrawSection from '../EyeDrawSection';
import thumb5 from '../images/thumb_05.jpg';
import thumb6 from '../images/thumb_06.jpg';
import thumb7 from '../images/thumb_07.jpg';
import thumb8 from '../images/thumb_08.jpg';
import thumb9 from '../images/thumb_09.jpg';
import thumb10 from '../images/thumb_10.jpg';
import thumb11 from '../images/thumb_11.jpg';
import img5 from '../images/5.png';
import img6 from '../images/6.png';
import img7 from '../images/7.png';
import img8 from '../images/8.png';
import img9 from '../images/9.png';
import img10 from '../images/10.png';
import img11 from '../images/11.png';

const cards = [
    { title: 'Eye Front', thumb: thumb5, image: img5 },
    { title: 'Eye 3/4', thumb: thumb6, image: img6 },
    { title: 'Eye Profile', thumb: thumb7, image: img7 },
    { title: 'Cutaway 1', thumb: thumb8, image: img8 },
    { title: 'Cutaway 2', thumb: thumb9, image: img9 },
    { title: 'Cutaway 3', thumb: thumb10, image: img10 },
    { title: 'Fundus', thumb: thumb11, image: img11 },
];

export default function EyeAnatomy() {
    return <EyeDrawSection id="eye-anatomy" title="Eye Anatomy" icon="bi-diagram-3" cards={cards} />;
}
